import { showErrorToast } from "./toast";

interface ApiErrorHandlerOptions {
  resourceName?: string;
  customMessages?: {
    [key: number]: string;
  };
}

export const handleApiError = (
  error: any,
  options: ApiErrorHandlerOptions = {}
) => {
  const { resourceName = "Resource", customMessages = {} } = options;

  let errorMessage = `Failed to process ${resourceName}`;

  if (error.response) {
    const { status, data } = error.response;

    if (data?.error_message) {
      errorMessage = data.error_message;
    } else if (customMessages[status]) {
      errorMessage = customMessages[status];
    } else {
      switch (status) {
        case 400:
          errorMessage = data?.message || data?.error || "Invalid request data";
          break;

        case 401:
          errorMessage = "Authentication required. Please login again";
          break;

        case 403:
          errorMessage = "You don't have permission to perform this action";
          break;

        case 404:
          errorMessage = data?.message || `${resourceName} not found`;
          break;

        case 409:
          errorMessage =
            data?.message || data?.error || `${resourceName} already exists`;
          break;

        case 422:
          if (data?.detail && Array.isArray(data.detail)) {
            errorMessage = data.detail
              .map((err: any) => `${"field"}: ${err.msg}`) //err.loc?.slice(-1)[0] ||
              .join(", ");
          } else {
            errorMessage = data?.message || "Validation failed";
          }
          break;

        case 500:
          errorMessage = "Server error. Please try again later";
          break;

        case 503:
          errorMessage = "Service temporarily unavailable";
          break;

        default:
          errorMessage = data?.message || data?.error || `Error: ${status}`;
      }
    }
  } else if (error.code === "ERR_NETWORK") {
    // Network error - likely CORS or server unreachable
    // Since we can't read the response due to CORS, show a generic message
    errorMessage = `Unable to connect to server. Please check if the ${resourceName} already exists or try again later.`;
  } else if (error.request) {
    errorMessage = "No response from server. Check your connection";
  } else {
    errorMessage = error.message || "An unexpected error occurred";
  }

  showErrorToast(errorMessage);
  return errorMessage;
};
